var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topTitle"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('br'),_c('span',{staticClass:"subTitle",staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.subTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }